import { styled, css } from 'styled-components';

export const ComponentSpacer = styled.div`
  ${({ theme }) => css`
    height: ${theme.spacing.outer.large};
    background: ${theme.colours.background.a};
  `}
`;
